/* @flow */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Password, Activity, Setting } from 'react-iconly';
import { ToastContainer } from 'react-toastify';
import { Row, Col } from '@nextui-org/react';

import HeaderComponent from '../Header';
import SideBar from './SideBar';
import { NavName } from './NavName';

import ClientSelector from '../ClientSelector';
import logo from '../../assets/mtt.png';

import { navShow, navHide } from '../../action/navigation';
import { mstore } from '../../store';
import { logoutAndClearStore } from '../../auth0';

const headerConnector = connect(
  state => ({
    isNavOpen: state.navigation.isNavOpen,
    name: mstore.get('user', 'name')
  }),
  {
    onNavShow: navShow,
    onNavHide: navHide
  }
);

const Header = headerConnector(HeaderComponent);

const MainComponent = ({
  isNavOpen,
  dispatch,
  children,
  links,
  title,
  Access,
  dcSettings
}) => {
    
    const isSuperAdmin = mstore.get('user', 'isSuperAdmin');
    const isAdmin = mstore.get('user', 'isAdmin');
    const isDriverAdmin = mstore.get('user', 'isDriverAdmin');
    const navWidth = isNavOpen ? '215px' : '56px'

    /**
     *
     * Element Styles, based on Navbar status
     *
     */

    const headerSettings =
        (isSuperAdmin || isAdmin || isDriverAdmin) && dcSettings ? (
        <NavLink to="/driver/settings" className="text-decoration-none">
            <div className="flex items-center justify-center p-2 rounded-lg hover:bg-gray-100 transition-colors">
                <Setting size='large' set='bold' className="text-secondary"/>
            </div>
        </NavLink>
        ) : null;

    

  return (
    <div className="h-full w-full bg-gray-50 flex flex-col overflow-hidden">
        <div className="flex-none">
            <ToastContainer />
            <Header
                leftTitle={<img src={logo} className="h-11 mt-1"/>}
                centerTitle={title}
                rightItem={headerSettings}
                onLogOut={logoutAndClearStore.bind(null, dispatch)}
            />
        </div>

        <Row className="flex-1 h-full overflow-hidden">
            <Col css={{ maxWidth: navWidth, minWidth: navWidth }}>
                <SideBar
                    style={{ width: navWidth }}
                    className="h-full pt-1 bg-white border-r border-gray-200 shadow-sm"
                    bottomWidget={isNavOpen && isSuperAdmin && <ClientSelector />}>
                    {links.map((l, i) => {
                        if ((!Access.allow_receipt_management || Access.allow_receipt_management === 0) && l.name === 'Reimbursable Receipt') {
                            return false;
                        }
                        if ((!Access.allow_ratings_artifax || Access.allow_ratings_artifax === 0) && l.name === 'Shipment Artifax™') {
                            return false;
                        }
                        if ((!Access.allow_artifax || Access.allow_artifax === 0) && l.name === 'Shipment Documents') {
                            return false;
                        }
                        if ((!Access.allow_osd || Access.allow_osd === 0) && l.name === 'OS&D') {
                            return false;
                        }
                        if ((!Access.allow_location_analytics || Access.allow_location_analytics === 0) && l.name === 'Location Analytics') {
                            return false;
                        }
                        if ((!Access.allow_location_info || Access.allow_location_info === 0) && l.name === 'Location Information') {
                            return false;
                        }
                        if ((!Access.allow_safety_documents || Access.allow_safety_documents === 0) && l.name === 'Safety') {
                            return false;
                        }
                        if ((!Access.allow_broker_shipment_management || Access.allow_broker_shipment_management === 0) && l.name === 'Shipment Management') {
                            return false;
                        }
                        if ((!Access.allow_detention_management || Access.allow_detention_management === 0) && l.name === 'Detention Management') {
                            return false;
                        }
                        if (!(isSuperAdmin || isAdmin || isDriverAdmin) && l.name === 'API Keys') {
                            return true;
                        }
                        if (l.name === 'News Feed' || l.name === 'API Keys') {
                            return false;
                        }
                        return (
                            <NavLink 
                                key={l.href} 
                                to={l.href} 
                                className="block py-1 text-gray-700 hover:bg-gray-100 transition-colors"
                            >
                                <NavName name={l.name} isNavOpen={isNavOpen} icon={l.icon}/>
                            </NavLink>
                        );
                    })}
                    <hr className="my-1 border-gray-200" />
                    <NavLink 
                        key='/driver/developer'
                        to='/driver/developer' 
                        className="block py-1 text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                        <NavName 
                            name='API Keys' 
                            isNavOpen={isNavOpen} 
                            icon={<Password set="light" filled primaryColor='gray'/>}
                        />
                    </NavLink>
                    {Access.allow_blog_posts === 1 && (
                        <>
                            <hr className="my-1 border-gray-200" />
                            <NavLink 
                                key='/driver/news-feed'
                                to="/driver/news-feed"
                                className="px-2 block py-1 text-gray-700 hover:bg-gray-100 transition-colors"
                            >
                                <NavName 
                                    name='News Feed' 
                                    isNavOpen={isNavOpen} 
                                    icon={<Activity set="light" filled primaryColor='gray'/>}
                                />
                            </NavLink>
                        </>
                    )}
                    {isSuperAdmin && title === 'MTT CONTROL' && (
                        <hr className="my-1 border-2 border-gray-300" />
                    )}
                </SideBar>
            </Col>
            <Col className={`flex-1 ${isNavOpen ? 'ml-4' : 'ml-2'} overflow-y-auto overflow-x-hidden h-full`}>
                {children}
            </Col>
        </Row>
    </div>
  );
};

export default connect(state => ({
  isNavOpen: state.navigation.isNavOpen,
  Access: state.navigation.Access
}))(MainComponent);
